export function getElementMargins(element: Element): { x: number; y: number } {
  const elementStyles = window.getComputedStyle(element);
  // Include margins into width/height computation
  const x = parseFloat(elementStyles.marginLeft) + parseFloat(elementStyles.marginRight);
  const y = parseFloat(elementStyles.marginTop) + parseFloat(elementStyles.marginBottom);
  return { x, y };
}
